import { render, staticRenderFns } from "./mvp-login2.vue?vue&type=template&id=19b418b6&scoped=true&"
import script from "./mvp-login2.vue?vue&type=script&lang=js&"
export * from "./mvp-login2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b418b6",
  null
  
)

export default component.exports